export class DipendenteVO {
    nome: string;
    cognome: string;
    cf: string;
    matricola: string;
    cmu: string;
    codiceEnte: string;
    output: string;
    descrizioneCmu: string;
}